import { useErpFundingStatsQuery } from 'core/graphql';

export type StatsDimension = 'funnel' | 'operator' | 'geo' | 'outcome_month';

/** Порядок вкладки аналитики. Зеркало `services/stats.py::DIMENSIONS`. */
export const STATS_DIMENSIONS: StatsDimension[] = [
  'funnel',
  'operator',
  'geo',
  'outcome_month',
];

/**
 * ТЗ 0024 — срез воронки.
 *
 * Фильтры те же, что у списка: аналитика обязана описывать то, что человек
 * видит в таблице, иначе два экрана про одни данные показывают разное.
 *
 * `error` НЕ проглатывается: неизвестное измерение сервер отвергает намеренно,
 * и экран должен сказать об этом, а не нарисовать пустой график.
 */
export const useFundingStats = (
  dimension: StatsDimension,
  filters: Record<string, unknown> = {},
) => {
  const { data, loading, error } = useErpFundingStatsQuery({
    variables: { dimension, ...filters },
    fetchPolicy: 'cache-and-network',
  });

  return { stats: data?.fundingCandidateStats ?? null, loading, error };
};
